// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.FinanceChargePlanPeriodResponse */
/* istanbul ignore next */
@GandalfModel
export class FinanceChargePlanPeriodResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	ageInDays!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	dollarCharge!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	percentCharge!: number | null;

}
